import { atomWithReset } from 'jotai/utils';

import { INITIAL_STATE_FILTERS, type StateFilters } from '../../types/stateFilters';

/**
 * Átomo com o estado dos filtros (client-side) da listagem de Estados.
 *
 * Deve ser consumido apenas via `useStateFilters` (CLAUDE.md proíbe `useAtom`
 * direto em componentes). Resetável via `useResetAtom`.
 */
export const stateFiltersAtom = atomWithReset<StateFilters>(INITIAL_STATE_FILTERS);
